// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FeaturedCollection_container__h4pZa {
  width: 100%;
  max-width: 95%;
  margin: 0 auto;
}

.FeaturedCollection_heading__w0Jco {
  font-size: 20px;
  font-weight: 700;
  color: white;
  margin-bottom: 1rem;
}

.FeaturedCollection_swiperWrapper__c\\+-fn {
  width: 100%;
  position: relative;
}

.FeaturedCollection_swiper__fens0 {
  width: 100%;
  padding-bottom: 20px;
}

.FeaturedCollection_card__7Q3lT {
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;
  height: 180px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  width: 100%;
}



.FeaturedCollection_content__HgRJO {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.5rem;
}

.FeaturedCollection_titleContainer__L1-eD {
  z-index: 10;
  position: relative;
  bottom: 1.5rem;
}

.FeaturedCollection_title__NYOt1 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: white;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);
}

/* Swiper navigation and pagination styles */
.FeaturedCollection_swiper__fens0 .swiper-button-prev,
.FeaturedCollection_swiper__fens0 .swiper-button-next {
  color: white;
  opacity: 0.8;
}

.FeaturedCollection_swiper__fens0 .swiper-button-prev:hover,
.FeaturedCollection_swiper__fens0 .swiper-button-next:hover {
  opacity: 1;
}

.FeaturedCollection_swiper__fens0 .swiper-pagination-bullet {
  background-color: white;
  opacity: 0.6;
}

.FeaturedCollection_swiper__fens0 .swiper-pagination-bullet-active {
  opacity: 1;
}

/* Media Queries for better responsiveness */
@media (min-width: 576px) {
  .FeaturedCollection_title__NYOt1 {
    font-size: 18px;
  }
  .FeaturedCollection_container__h4pZa{
    max-width: 100%;
  }
}

@media (min-width: 768px) {
  .FeaturedCollection_container__h4pZa {
    width: 100%;
    max-width: 95%;
    margin: 0 auto;
  }
  
  .FeaturedCollection_card__7Q3lT {
    height: 200px;
  }
  
  .FeaturedCollection_title__NYOt1 {
    font-size: 20px;
  }
 
}

@media (max-width: 480px) {
  .FeaturedCollection_card__7Q3lT {
    height: 150px;
  }
  .FeaturedCollection_container__h4pZa{
    padding: 0rem;

  }
  .FeaturedCollection_titleContainer__L1-eD {
    bottom: -1.5rem;
  }
  
  .FeaturedCollection_title__NYOt1 {
    font-size: 12px;
  }
  
  .FeaturedCollection_heading__w0Jco {
    font-size: 18px;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
  }
  
  .FeaturedCollection_content__HgRJO {
    padding: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Homepage/components/Css/FeaturedCollection.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;;;AAIA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,2CAA2C;AAC7C;;AAEA,4CAA4C;AAC5C;;EAEE,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,4CAA4C;AAC5C;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;;EAEf;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".container {\n  width: 100%;\n  max-width: 95%;\n  margin: 0 auto;\n}\n\n.heading {\n  font-size: 20px;\n  font-weight: 700;\n  color: white;\n  margin-bottom: 1rem;\n}\n\n.swiperWrapper {\n  width: 100%;\n  position: relative;\n}\n\n.swiper {\n  width: 100%;\n  padding-bottom: 20px;\n}\n\n.card {\n  position: relative;\n  border-radius: 5px;\n  overflow: hidden;\n  cursor: pointer;\n  height: 180px;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n\n\n.content {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 1.5rem;\n}\n\n.titleContainer {\n  z-index: 10;\n  position: relative;\n  bottom: 1.5rem;\n}\n\n.title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: white;\n  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);\n}\n\n/* Swiper navigation and pagination styles */\n.swiper :global(.swiper-button-prev),\n.swiper :global(.swiper-button-next) {\n  color: white;\n  opacity: 0.8;\n}\n\n.swiper :global(.swiper-button-prev:hover),\n.swiper :global(.swiper-button-next:hover) {\n  opacity: 1;\n}\n\n.swiper :global(.swiper-pagination-bullet) {\n  background-color: white;\n  opacity: 0.6;\n}\n\n.swiper :global(.swiper-pagination-bullet-active) {\n  opacity: 1;\n}\n\n/* Media Queries for better responsiveness */\n@media (min-width: 576px) {\n  .title {\n    font-size: 18px;\n  }\n  .container{\n    max-width: 100%;\n  }\n}\n\n@media (min-width: 768px) {\n  .container {\n    width: 100%;\n    max-width: 95%;\n    margin: 0 auto;\n  }\n  \n  .card {\n    height: 200px;\n  }\n  \n  .title {\n    font-size: 20px;\n  }\n \n}\n\n@media (max-width: 480px) {\n  .card {\n    height: 150px;\n  }\n  .container{\n    padding: 0rem;\n\n  }\n  .titleContainer {\n    bottom: -1.5rem;\n  }\n  \n  .title {\n    font-size: 12px;\n  }\n  \n  .heading {\n    font-size: 18px;\n    margin-bottom: 0.5rem;\n    margin-top: 0.5rem;\n  }\n  \n  .content {\n    padding: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FeaturedCollection_container__h4pZa`,
	"heading": `FeaturedCollection_heading__w0Jco`,
	"swiperWrapper": `FeaturedCollection_swiperWrapper__c+-fn`,
	"swiper": `FeaturedCollection_swiper__fens0`,
	"card": `FeaturedCollection_card__7Q3lT`,
	"content": `FeaturedCollection_content__HgRJO`,
	"titleContainer": `FeaturedCollection_titleContainer__L1-eD`,
	"title": `FeaturedCollection_title__NYOt1`
};
export default ___CSS_LOADER_EXPORT___;
